import moment from 'moment'

export default {
  methods: {
    safeDate (value) {
      let date = ''

      if (moment(value, 'YYYY-MM-DD', true).isValid()) {
        date = moment(value, 'YYYY-MM-DD').format('DD.MM.YYYY')
      }

      return date
    },
  },
}
